<script lang="ts">
  import { currentTreeId, currentTree, createPerson, updateTree, go, selectedPersonId } from '../lib/stores';
  import TreeCanvas from './TreeCanvas.svelte';
  import PersonEditor from './PersonEditor.svelte';
  import CommentsPanel from './CommentsPanel.svelte';
  import ShareDialog from './ShareDialog.svelte';
  import GedcomTools from './GedcomTools.svelte';

  export let treeId: string;
  export let personId: string | undefined = undefined;

  let shareOpen = false;
  let editingTitle = false;
  let titleDraft = '';

  $: currentTreeId.set(treeId);
  $: if (personId) selectedPersonId.set(personId);

  async function addPerson() {
    if (!treeId) return;
    const p = await createPerson(treeId, { name: 'New person' });
    selectedPersonId.set(p.id);
  }

  async function commitTitle() {
    if (!$currentTree) return;
    await updateTree($currentTree.id, { title: titleDraft || $currentTree.title });
    editingTitle = false;
  }

  function short(id?: string) { return id ? id.slice(0, 8) : ''; }
</script>

<div class="shell">
  <div class="bar">
    <button class="ghost small" on:click={() => go('/')}>← trees</button>
    <span class="sep"></span>
    {#if $currentTree}
      {#if editingTitle}
        <input class="title-input" bind:value={titleDraft} on:blur={commitTitle}
               on:keydown={(e) => e.key === 'Enter' && commitTitle()} />
      {:else}
        <button class="title ghost"
                on:click={() => { titleDraft = $currentTree?.title ?? ''; editingTitle = true; }}>
          {$currentTree.title}
        </button>
      {/if}
      <span class="chip">tree.{short($currentTree.id)}</span>
      <span class="chip {$currentTree.visibility === 'public' ? 'gold' : ''}">{$currentTree.visibility}</span>
    {/if}
    <div class="spacer" />
    <GedcomTools />
    <button class="primary small" on:click={addPerson} title="Adds a new person, unlinked. Right-click them to add parents/children/spouse.">+ person</button>
    <button class="small" on:click={() => (shareOpen = true)}>share…</button>
    <button class="ghost small" on:click={() => go(`/audit/${treeId}`)}>audit</button>
  </div>

  <div class="body">
    <TreeCanvas />
    <PersonEditor />
  </div>
  <div class="drawer-comments">
    <CommentsPanel />
  </div>
</div>

<ShareDialog bind:open={shareOpen} />

<style>
  .shell {
    display: grid;
    grid-template-rows: auto 1fr;
    height: calc(100vh - var(--ls-nav-h));
    position: relative;
  }
  .bar {
    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    padding: 8px 14px;
    background: color-mix(in srgb, var(--ls-surface) 85%, transparent);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-bottom: 1px solid var(--ls-border);
  }
  .sep { width: 1px; height: 18px; background: var(--ls-border); margin: 0 4px; }
  .spacer { flex: 1; }
  .title, .title-input {
    background: transparent; border: none; padding: 4px 8px;
    font-family: var(--ls-font-display); font-weight: 500;
    font-size: var(--ls-step-3); color: var(--ls-ink);
    width: auto; letter-spacing: -0.02em;
  }
  .title-input { border: 1px solid var(--ls-border); background: var(--ls-bg-2); }
  .title:hover { background: var(--ls-surface-2); border-radius: var(--ls-radius); }
  .body { position: relative; overflow: hidden; }
  .drawer-comments {
    position: absolute; right: 16px; top: calc(var(--ls-nav-h) + 70px);
    width: calc(var(--ls-drawer-w) - 32px);
    max-height: 38vh;
    overflow: auto;
    pointer-events: auto;
  }
  @media (max-width: 900px) { .drawer-comments { display: none; } }
</style>
